import { useSelector } from 'react-redux';

export default () => {
	const cmsClientEnv = useSelector(s => s.app.clientEnv);

	if (['local', 'dev'].includes(cmsClientEnv))
		return ['local', 'dev'];
	else if (['sandbox'].includes(cmsClientEnv))
		return['sandbox'];
	else if (['stg', 'prod'].includes(cmsClientEnv))
		return ['stg', 'prod'];

	return [];
};
